function SSReplayScreen(config){
  this.config = config;
  this.html = config.settings.html;
  
  this._init();
}

SSReplayScreen.prototype._init = function(){

};

SSReplayScreen.prototype.show = function(dimensions){
  if (this.overlay !== undefined){
    return;
  }
  this.overlay = $('<div/>').css({
    width : '100%',
    height : '100%',
    'background-color' : 'black',
    opacity : 0.75,
    position : 'absolute',
    top : 0,
    left : 0
  }).appendTo(this.config.renderTo);
  this.lastScreen = $('<div/>').css({
    position : 'absolute'
  }).html(this.html).appendTo(this.config.renderTo);
  this.setDimensions(dimensions);
  this.bindEvents();
};

SSReplayScreen.prototype.destroy = function(){
  if(this.overlay){
    this.overlay.remove();
    delete(this.overlay);
  }
  if(this.lastScreen){
    this.lastScreen.remove();
    delete(this.lastScreen);
  }
};

SSReplayScreen.prototype.bindEvents = function(){
  var that = this;
  this.lastScreen.find('.j-replay-button').bind('click', function(e){
    e.preventDefault();
    that.destroy();
    $.slideshareEventManager.trigger('gotofirstslide');
    $.slideshareEventManager.trackEvent('lastscreen_replay');
  });
};

SSReplayScreen.prototype.setDimensions = function(dimensions){
  if (this.lastScreen === undefined){
    return;
  }
  var layerWidth = 93;
  var layerHeight = 25;
  var top, left;
  top = (dimensions.height - layerHeight)/2;
  left = (dimensions.width - layerWidth)/2;
  if (top<0){
    top = 0;
  } else {
    top = parseInt(top, 10);
  }
  
  if (left<0){
    left = 0;
  } else {
    left = parseInt(left, 10);
  }
  
  this.lastScreen.css({
    top : top,
    left : left
  });
};
